// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.utilization-panel[data-v-4c77ea02] {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.utilization-panel .experience-score-header[data-v-4c77ea02] {
  color: var(--filter-text-color);
  font-size: 24px;
  font-weight: 800;
}
.utilization-panel .utilization-kpi[data-v-4c77ea02] {
  flex-grow: 1;
  max-width: 100%;
  max-height: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.utilization-panel .utilization-kpi .kpi[data-v-4c77ea02] {
  font-weight: 800;
  font-size: 36px;
  color: var(--text-color);
}
.utilization-panel .utilization-kpi .kpi .percent[data-v-4c77ea02] {
  font-size: 24px;
  position: relative;
  top: -4px;
}
.utilization-panel .countText[data-v-4c77ea02] {
  text-align: center;
  color: var(--text-color);
}`, "",{"version":3,"sources":["webpack://./js/modules/admin/components/Entitlements/UtilizationPanel.vue","webpack://./UtilizationPanel.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;ACAF;ADCE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;ACCJ;ADEE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACAJ;ADCI;EACE,gBAAA;EACA,eAAA;EACA,wBAAA;ACCN;ADAM;EACE,eAAA;EACA,kBAAA;EACA,SAAA;ACER;ADEE;EACE,kBAAA;EACA,wBAAA;ACAJ","sourcesContent":["\n.utilization-panel {\n  padding: 15px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  .experience-score-header {\n    color: var(--filter-text-color);\n    font-size: 24px;\n    font-weight: 800;\n  }\n\n  .utilization-kpi {\n    flex-grow: 1;\n    max-width: 100%;\n    max-height: 190px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .kpi {\n      font-weight: 800;\n      font-size: 36px;\n      color: var(--text-color);\n      .percent {\n        font-size: 24px;\n        position: relative;\n        top: -4px;\n      }\n    }\n  }\n  .countText {\n    text-align: center;\n    color: var(--text-color);\n  }\n}\n",".utilization-panel {\n  padding: 15px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.utilization-panel .experience-score-header {\n  color: var(--filter-text-color);\n  font-size: 24px;\n  font-weight: 800;\n}\n.utilization-panel .utilization-kpi {\n  flex-grow: 1;\n  max-width: 100%;\n  max-height: 190px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.utilization-panel .utilization-kpi .kpi {\n  font-weight: 800;\n  font-size: 36px;\n  color: var(--text-color);\n}\n.utilization-panel .utilization-kpi .kpi .percent {\n  font-size: 24px;\n  position: relative;\n  top: -4px;\n}\n.utilization-panel .countText {\n  text-align: center;\n  color: var(--text-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
